var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 43,
    height: 42,
    transform: "translate(0.216 0.431)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(-605 -2818)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(605 2818)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(616.784 2829.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M20.383,32.749A11.46,11.46,0,0,1,16.32,31.7a.964.964,0,0,0-1.282.466l-1.21,2.595A15.493,15.493,0,0,1,7.661,28.59l2.594-1.209a.964.964,0,0,0,.466-1.282,11.47,11.47,0,0,1-1.052-4.064A1.931,1.931,0,0,0,7.75,20.245H.964A.965.965,0,0,0,0,21.209,21.233,21.233,0,0,0,21.209,42.419a.965.965,0,0,0,.964-.964V34.669a1.932,1.932,0,0,0-1.79-1.92m-.138,7.718A19.307,19.307,0,0,1,1.952,22.173l5.795,0A13.386,13.386,0,0,0,8.6,26.026L5.945,27.263a.964.964,0,0,0-.466,1.282,17.423,17.423,0,0,0,8.4,8.4.964.964,0,0,0,1.282-.466l1.237-2.653a13.284,13.284,0,0,0,3.853.847Zm-.964-21.185v-.964a.965.965,0,0,0-.964-.964H15.425a.964.964,0,0,1,0-1.928h2.892a2.9,2.9,0,0,1,2.892,2.892v.964a2.9,2.9,0,0,1-2.892,2.892h-.964a.965.965,0,0,0-.964.964v1.928h3.856a.964.964,0,1,1,0,1.928h-4.82a.965.965,0,0,1-.964-.964V23.138a2.9,2.9,0,0,1,2.892-2.892h.964a.965.965,0,0,0,.964-.964m8.677,2.892H24.1a.965.965,0,0,1-.964-.964v-4.82a.964.964,0,0,1,1.928,0v3.856h2.892V16.389a.964.964,0,0,1,1.928,0V26.03a.964.964,0,0,1-1.928,0Zm14.461-.964A21.232,21.232,0,0,1,26.7,41.7a.976.976,0,0,1-.25.033.964.964,0,0,1-.248-1.9,19.182,19.182,0,0,0,7.941-4.332l-2.026-2.026a.964.964,0,1,1,1.363-1.363l2.027,2.027a19.3,19.3,0,0,0,4.957-11.971H37.6a.964.964,0,1,1,0-1.928h2.868A19.207,19.207,0,0,0,35.5,8.282L33.48,10.3A.964.964,0,0,1,32.116,8.94l2.021-2.021A19.2,19.2,0,0,0,22.173,1.953V4.82a.964.964,0,0,1-1.928,0V1.955A19.3,19.3,0,0,0,8.275,6.911L10.3,8.939A.964.964,0,1,1,8.939,10.3L6.913,8.276a19.179,19.179,0,0,0-4.332,7.941.964.964,0,0,1-1.863-.5,21.212,21.212,0,0,1,41.7,5.49",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group5.4371cb22588d29c53edff7cf03c5c111.svg";
export { ForwardRef as ReactComponent };